import { Transformer, useApiQuery } from "~/hooks";
import { QUERY_DATA_SOURCE_ENDPOINT } from "~/utils/Constants";
import { LooseObject } from "~/utils/Types";

type DataSourceQueryProps = {
  enabled?: boolean;
  params: LooseObject;
  shouldDecodeSuccess?: boolean;
  shouldOptimiseQueryResult?: boolean;
  transformers?: Transformer[];
};

export const useDataSourceQuery = ({
  enabled = true,
  params,
  shouldDecodeSuccess = true,
  shouldOptimiseQueryResult = true,
  transformers = [],
}: DataSourceQueryProps) => {
  return useApiQuery({
    config: {
      data: params,
      method: "post",
    },
    enabled,
    path: "/user/" + QUERY_DATA_SOURCE_ENDPOINT,
    shouldDecodeSuccess,
    shouldOptimiseQueryResult,
    transformers,
  });
};
